import { NEODataProvider } from './NEODataProvider';
import { ProviderBase } from './ProviderBase';
export class NEOProvider extends ProviderBase {
    constructor(options = []) {
        super();
        const networks = options.map((opts) => {
            this.mutableProviders[opts.network] = opts instanceof NEODataProvider ? opts : new NEODataProvider(opts);
            return opts.network;
        });
        this.networksInternal$.next(networks);
    }
    createDataProvider(options) {
        return new NEODataProvider(options);
    }
}

//# sourceMappingURL=NEOProvider.js.map
